import { render, staticRenderFns } from "./associated-proofs.vue?vue&type=template&id=4d0f5f7c&scoped=true&"
import script from "./associated-proofs.vue?vue&type=script&lang=js&"
export * from "./associated-proofs.vue?vue&type=script&lang=js&"
import style0 from "./associated-proofs.vue?vue&type=style&index=0&id=4d0f5f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0f5f7c",
  null
  
)

export default component.exports